import { CtaOverlay as CtaOverlayComponent } from "./CtaOverlay.component";
import { CtaOverlayProps } from "./CtaOverlay.types";
import * as CtaOverlayVariants from "./CtaOverlay.variants";

export const DefaultCtaOverlay = ({ ...props }: Partial<CtaOverlayProps>) => (
  <CtaOverlayComponent { ...{ ...CtaOverlayVariants.Default, ...props } }/>
);

export const CtaOverlay = CtaOverlayComponent;
